import React, { useContext, useState, useEffect } from "react";
import Form from "../../../../../assets/Style/Form.module.css";
import acm from "../AddCarModal.module.css";
import cpf from "./SalerPriceForm.module.css";
import { useAuth } from "../../../../../providers/authProvider";
import { AppContext } from "../../../../../providers/appProvider";
import { INSPECTION_WEBSITE_ID } from "../../../../../utils/constans";
import { baseFileURL } from '../../../../../Api';
import { useTranslation } from 'react-i18next';

const SalerPriceForm = ({ newCar, setNewCar, isAdd, prices }) => {
  const { t } = useTranslation();
  
  const { appState, app } = useContext(AppContext);
  var salerPrice = prices.salerPrice;
  var percent = prices.salerPercent;
  var [rawSalerPriceInternal, setRawClientPriceInternal] = useState(newCar.client_price_internal)

  useEffect(() => {
    setRawClientPriceInternal(newCar.client_price_internal);
    setRawClientPriceInternal(newCar.saler_price_internal);
  }, [newCar.client_price_internal, newCar.saler_price_internal]);

  useEffect(() => {
    if(baseFileURL == 'https://finance.automoby.ge') {
      setNewCar((prevState) => ({
        ...prevState,
        saler_price_insurance: newCar.saler_price_insurance == 0 ? 0 : Math.max(newCar.client_price_insurance - 50, 0),
        saler_price_transfer_fee: 30 
      }));
    } else {
      setNewCar((prevState) => ({
        ...prevState,
        saler_price_insurance: newCar.saler_price_insurance == 0 ? 0 : Math.max(newCar.client_price_insurance - 50, 0),
        saler_price_transfer_fee: newCar.saler_price_transfer_fee == 0 ? 0 : Math.max(newCar.client_price_transfer_fee - 60, 0),
      }));
    }
  }, [setNewCar]);

  const handleChange = (event) => {
    let val = convertToInt(event.target.value);
    setNewCar({
      ...newCar,
      [event.target.name]: val,
    });
  };

  const handleChangeInsurance = (event) => {
    let val = convertToInt(event.target.value);

    setNewCar({
      ...newCar,
      saler_price_insurance: val,
    });
  };

  const handleBlurInsurance = () => {
    let calculatedInsurance = newCar.client_price_car;
    if(!app.hasPermission('HAS_SUPERUSER_ROLE')) {
      if(newCar.insurance === 1) {
        calculatedInsurance = Math.max(Math.ceil(newCar.client_price_car * 0.005), 50);
  
        if (newCar.client_price_insurance < calculatedInsurance) {
          setNewCar({
            ...newCar,
            saler_price_insurance: calculatedInsurance,
          });
        }
      }
    } else {
      setNewCar({
        ...newCar,
        saler_price_insurance: newCar.saler_price_insurance,
      });
    }
  };

  function convertToInt(str) {
    const num = parseInt(str, 10);
    return isNaN(num) ? 0 : num;
  }

  const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const regex = /^[0-9]+$/;

    if (!regex.test(keyValue)) {
      event.preventDefault();
    }
  };

  const handleFocus = (e) => {
    if (!app.hasPermission("SALER_PRICE_EDIT")) {
      return;
    }

    if (e.target.value === "0") {
      setNewCar({
        ...newCar,
        [e.target.name]: "",
      });
    }
  };  

  const handleBlur = (e) => {
    if (!app.hasPermission("SALER_PRICE_EDIT")) {
      return;
    }

    if (e.target.value === "") {
      let val = convertToInt(0);
      setNewCar({
        ...newCar,
        [e.target.name]: val,
      });
    }
  };

  var isDisable = !app.hasPermission("SALER_PRICE_EDIT");

  if (newCar.website_id === INSPECTION_WEBSITE_ID) {
    isDisable = true;
  }
  return (
    <fieldset className={acm.formField}>
      <legend>{t('SalerPrice')}</legend>

      <div className={cpf.groupPrice}>
        <label className={cpf.leftLabel}>{t('CarPrice')}</label>
        <div className={cpf.rightInput}>
          <div className={Form.priceInput}>
            <div className={Form.priceCurrency}>USD</div>
            <input
              type="text"
              onFocus={handleFocus}
              onBlur={handleBlur}
              onKeyPress={handleKeyPress}
              className={Form.input}
              name="saler_price_car"
              onChange={handleChange}
              value={newCar.saler_price_car}
              min="0"
              readOnly={isDisable}
            />
            <div className={Form.hundred}>.00</div>
          </div>
        </div>
      </div>

      <div className={cpf.groupPrice}>
        <label className={cpf.leftLabel}>{t('ContainerPrice')}</label>
        <div className={cpf.rightInput}>
          <div className={Form.priceInput}>
            <div className={Form.priceCurrency}>USD</div>

            {app.hasPermission("SALER_PRICE_EDIT") ? (
              <input
                type="text"
                onKeyPress={handleKeyPress}
                name="saler_price_transport"
                className={Form.input}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                value={newCar.saler_price_transport}
              />
            ) : (
              <input
                type="text"
                onKeyPress={handleKeyPress}
                name="saler_price_transport"
                className={Form.input}
                value={newCar.saler_price_transport}
                readonly
              />
            )}

            <div className={Form.hundred}>.00</div>
          </div>
        </div>
      </div>

      <div className={cpf.groupPrice}>
        <label className={cpf.leftLabel}>{t('InternalTransportation')}</label>
        <div className={cpf.rightInput}>
          <div className={Form.priceInput}>
            <div className={Form.priceCurrency}>USD</div>

            {app.hasPermission("SALER_PRICE_EDIT") ? (
              <input
                  type="text"
                  onKeyPress={handleKeyPress}
                  name="saler_price_internal"
                  className={Form.input}
                  value={rawSalerPriceInternal}
                  onChange={(event) => {
                    const value = event.target.value;
                    setRawClientPriceInternal(value); 
                    setNewCar({ ...newCar, saler_price_internal: convertToInt(value) }); 
                  }}
                  onFocus={(event) => {
                    handleFocus(event);
                    if (event.target.value === "0") {
                      setRawClientPriceInternal(""); 
                    }
                  }}
                  onBlur={(event) => {
                    if (event.target.value.trim() === "") {
                      const defaultValue = 0; 
                      setRawClientPriceInternal(defaultValue); 
                      setNewCar({ ...newCar, saler_price_internal: defaultValue }); 
                    }
                    handleBlur(event); 
                  }}
                  min={0}
                  readOnly={isDisable}
                />
            ) : (
              <input
                type="text"
                onKeyPress={handleKeyPress}
                name="saler_price_internal"
                className={Form.input}
                value={newCar.saler_price_internal}
                readonly
              />
            )}

            <div className={Form.hundred}>.00</div>
          </div>
        </div>
      </div>

      <div className={cpf.groupPrice}>
        <label className={cpf.leftLabel}>{t('Procent')}</label>
        <div className={cpf.rightInput}>
          <div className={Form.priceInput}>
            <div className={Form.priceCurrency}>USD</div>
            <input
              type="text"
              disabled={true}
              className={Form.input}
              value={percent}
              min="0"
              readOnly
            />
            <div className={Form.hundred}>.00</div>
          </div>
        </div>
      </div>

      {newCar.dealer_id > 0 && (
        <>
        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('DealerCommissionCar')}</label>
          <div className={cpf.rightInput}>
            <div className={Form.priceInput}>
              <div className={Form.priceCurrency}>USD</div>
              <input
                type="text"
                onKeyPress={handleKeyPress}
                onChange={handleChange}
                name="saler_price_dealer"
                className={Form.input}
                value={newCar.saler_price_dealer}
                min="0"
                readOnly={isDisable}
              />
              <div className={Form.hundred}>.00</div>
            </div>
          </div>
        </div>
        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('DealerCommissionTransport')}</label>
          <div className={cpf.rightInput}>
            <div className={Form.priceInput}>
              <div className={Form.priceCurrency}>USD</div>
              <input
                type="text"
                onKeyPress={handleKeyPress}
                onChange={(event) => {
                    let val = convertToInt(event.target.value);
                    setNewCar({
                      ...newCar,  
                      saler_price_dealer_transport: val,
                    });
                }}
                name="saler_price_dealer_transport"
                className={Form.input}
                value={newCar.saler_price_dealer_transport}
                min="0"
                readOnly={isDisable}
              />
              <div className={Form.hundred}>.00</div>
            </div>
          </div>
        </div>
        </>
      )}

      <div className={cpf.groupPrice}>
        <label className={cpf.leftLabel}>{t('DocumentPrice')}</label>
        <div className={cpf.rightInput}>
          <div className={Form.priceInput}>
            <div className={Form.priceCurrency}>USD</div>
            <input
              type="text"
              onFocus={handleFocus}
              onBlur={handleBlur}
              onKeyPress={handleKeyPress}
              name="saler_price_document"
              className={Form.input}
              onChange={handleChange}
              value={newCar.saler_price_document}
              min="0"
              readOnly={isDisable}
            />
            <div className={Form.hundred}>.00</div>
          </div>
        </div>
      </div>

      <div className={cpf.groupPrice}>
        <label className={cpf.leftLabel}>{t('Insurance')}</label>
        <div className={cpf.rightInput}>
          <div className={Form.priceInput}>
            <div className={Form.priceCurrency}>USD</div>
            {app.hasPermission("SALER_INSURANCE_EDIT") ? (
              <input
                type="text"
                onFocus={handleFocus}
                onBlur={handleBlurInsurance}
                onKeyPress={handleKeyPress}
                name="saler_price_insurance"
                className={Form.input}
                onChange={handleChangeInsurance}
                value={newCar.saler_price_insurance}
                readOnly={isDisable}
              />
            ) : (
              <input                
                type="text"
                onKeyPress={handleKeyPress}
                name="saler_price_insurance"
                className={Form.input}
                value={newCar.saler_price_insurance}
                readonly
              />
            )}
            <div className={Form.hundred}>.00</div>
          </div>
        </div>
      </div>

      <div className={cpf.groupPrice}>
        <label className={cpf.leftLabel}>{t('Penalty')}</label>
        <div className={cpf.rightInput}>
          <div className={Form.priceInput}>
            <div className={Form.priceCurrency}>USD</div>
            <input
              type="text"
              onFocus={handleFocus}
              onBlur={handleBlur}
              onKeyPress={handleKeyPress}
              name="saler_price_penalty"
              className={Form.input}
              onChange={handleChange}
              value={newCar.saler_price_penalty}
              min="0"
              readOnly={isDisable}
            />
            <div className={Form.hundred}>.00</div>
          </div>
        </div>
      </div>

      <div className={cpf.groupPrice}>
        <label className={cpf.leftLabel}>{t('TransferFee')}</label>
        <div className={cpf.rightInput}>
          <div className={Form.priceInput}>
            <div className={Form.priceCurrency}>USD</div>
            <input
              type="text"
              onFocus={handleFocus}
              onBlur={handleBlur}
              onKeyPress={handleKeyPress}
              name="saler_price_transfer_fee"
              className={Form.input}
              onChange={handleChange}
            //  value={newCar.saler_price_transfer_fee}
              value={
                baseFileURL === 'https://finance.automoby.ge'
                  ? (newCar.saler_price_transfer_fee === 60 ? 30 : newCar.saler_price_transfer_fee)
                  : newCar.saler_price_transfer_fee
              }
              min="0"
              readOnly={isDisable}
            />
            <div className={Form.hundred}>.00</div>
          </div>
        </div>
      </div>


      <div className={cpf.groupPrice}>
        <label className={cpf.leftLabel}>{t('Inspection')}</label>
        <div className={cpf.rightInput}>
          <div className={Form.priceInput}>
            <div className={Form.priceCurrency}>USD</div>
            <input
              type="text"
              disabled={!app.hasPermission("SALER_PRICE_EDIT")}
              onFocus={handleFocus}
              onBlur={handleBlur}
              onKeyPress={handleKeyPress}
              name="saler_price_inspection"
              className={Form.input}
              onChange={handleChange}
              value={newCar.saler_price_inspection}
              min="0"
            />
            <div className={Form.hundred}>.00</div>
          </div>
        </div>
      </div>


      <div className={cpf.groupPrice}>
        <label className={cpf.leftLabel}>{t('Other')}</label>
        <div className={cpf.rightInput}>
          <div className={Form.priceInput}>
            <div className={Form.priceCurrency}>USD</div>
            <input
              type="text"
              onFocus={handleFocus}
              onBlur={handleBlur}
              onKeyPress={handleKeyPress}
              name="saler_price_another"
              className={Form.input}
              onChange={handleChange}
              value={newCar.saler_price_another}
              min="0"
              readOnly={isDisable}
            />
            <div className={Form.hundred}>.00</div>
          </div>
        </div>
      </div>

      <div className={cpf.groupPrice}>
        <label className={cpf.leftLabel}>{t('RequestedAmount')}</label>
        <div className={cpf.rightInput}>
          <div className={Form.priceInput}>
            <div className={Form.priceCurrency}>USD</div>
            <input
              type="text"
              onFocus={handleFocus}
              onBlur={handleBlur}
              onKeyPress={handleKeyPress}
              name="saler_price_fund"
              className={Form.input}
              onChange={handleChange}
              value={newCar.saler_price_fund}
              min="0"
              readOnly={isDisable || newCar.fund_accept}
            />
            <div className={Form.hundred}>.00</div>
          </div>
        </div>
      </div>

      <div className={cpf.groupPrice}>
        <label className={cpf.leftLabel}>{t('RequestProcent')}</label>
        <div className={cpf.rightInput}>
          <div className={Form.priceInput}>
            <div className={Form.priceCurrency}>USD</div>
            <input
              type="text"
              min="0"
              max="100"
              onFocus={handleFocus}
              onBlur={handleBlur}
              onKeyPress={handleKeyPress}
              name="saler_percent_fund"
              className={Form.input}
              onChange={handleChange}
              value={newCar.saler_percent_fund}
              readOnly={!app.hasPermission("FUND_PERCENT_EDIT") || isDisable}
            />
            <div className={Form.hundred}>.00</div>
          </div>
        </div>
      </div>


      <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('Discount')}</label>
          <div className={cpf.rightInput}>
            <div className={Form.priceInput}>
              <div className={Form.priceCurrency}>USD</div>
              <input
                type="text"
                disabled={!app.hasPermission("PRICE_DISCOUNT_EDIT") || isDisable}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyPress={handleKeyPress}
                name="saler_price_discount"
                className={Form.input}
                onChange={handleChange}
                max="100"
                value={newCar.saler_price_discount}
                min="0"
              />
              <div className={Form.hundred}>.00</div>
            </div>
          </div>
        </div>




 

      <div className={cpf.TotalPrice}>
        <div className={cpf.paramTotal}></div>
        <div className={cpf.priceCredit}>
          <span className={cpf.curr}>USD</span>
          {salerPrice}
        </div>
      </div>
    </fieldset>
  );
};

export default SalerPriceForm;





